import $ from 'jquery';

const initializeTooltipsByContext = (vm) => {
    const context = vm.$el;

    //Tooltips should be explicitly marked as such
    let filter = '[data-toggle="tooltip"]';
    
    //Hack: when possible; limit our selection to only the current scope
    //Due to Vue's scopeId not being publicly available, take a peek at its privates
    //Assumed format: data-abc123...
    if(vm.$options._scopeId && /^data-.+/.test(vm.$options._scopeId)){
        filter += `[${vm.$options._scopeId}]`;
    }
    
    //Limit our search to the current component
    $(context)
        .find(filter)
        .tooltip();
};

const initializeTooltips = {
    methods: {
        initializeTooltips: function(){
            initializeTooltipsByContext(this);
        }
    }
};

const autoInitializeTooltips = {
    //On mount we should have an element to work with
    mounted() {
        initializeTooltipsByContext(this);
    }
};

export {
    autoInitializeTooltips,
    initializeTooltips 
};

export default initializeTooltips;